var _style, _g, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanningicona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlnsSerif: "http://www.serif.com/",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 205.5 205.1",
    style: {
      enableBackground: "new 0 0 205.5 205.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t.st2{fill:none;stroke:#000000;stroke-width:2.9992;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t.st4{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02347,0,0,1.02624,-35.0787,-65.6648)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.3,81.4c0-8.6-7-15.6-15.6-15.6H85.4c-8.6,0-15.6,7-15.6,15.6v157.3c0,8.6,7,15.6,15.6,15.6h130.3 c8.6,0,15.6-7,15.6-15.6V81.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0020912,0,0,0.99073,1149.62,24.1626)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-492615.6-20.8c0,0.3,2.1,193.5,2.1,193.5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.9,31.6l162.8-0.1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.07548,214.051)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.8-131.1l162.8-0.1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.498556,431.29)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.2-296.2l162.8-0.1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.08714,-0.0014193,0.00115039,-0.881165,1994.75,4505.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1823.4,4903.1c0-10.4-6.9-18.9-15.3-18.9h-69.7c-8.4,0-15.3,8.5-15.3,18.9v37.7c0,10.4,6.9,18.9,15.3,18.9 h17.3l19.6,13.8l-1.7-13.8h34.5c8.4,0,15.3-8.5,15.3-18.9V4903.1z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0853617,0.000425006,0.000425006,1,700.303,487.392)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-7874.5-328.4l162.8-0.1"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0577363,0.000437842,0.000437842,1,786.694,-63.6984)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-12875.7,85.7l162.8-0.1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0577363,0.000437842,0.000437842,1,853.975,-63.6984)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-13761.5,86.1l594.6-0.3"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.144779,0.000397396,0.000397396,1,1061.52,-63.5991)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-6460.5,82.6l162.8-0.1"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.144779,0.000397396,0.000397396,1,1226.44,-63.5991)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-7326.3,82.9l162.8-0.1"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.367393,0.000293954,0.000293954,1,557.03,487.499)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-1384-331.5l162.8-0.1"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.367393,0.000293954,0.000293954,1,469.994,605.441)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-1203.9-428.2l162.8-0.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningicona);
export default __webpack_public_path__ + "static/media/planningicona.e274b3421f4480d7f5d12c392f0a767a.svg";
export { ForwardRef as ReactComponent };